import {
  OpenExponentConversationEvent,
  OpenExponentSocialsEvent,
  OpenExponentWebsiteEvent,
} from "@ac-expo/api-types";
import { ParticipationPanel } from "@ac-expo/ui-components";
import { EventScheduleType } from "@ac-expo/utils";
import { ComponentProps, FC } from "react";
import ExhibitorDrawerUnified from "./ExhibitorDrawerUnified";

type ExhibitorProps = {
  exhibitorId: string;
  eventId?: string;
  eventSchedules?: EventScheduleType[];
  isOpen: boolean;
  onClose: () => void;
  getAppEventClickHandler?: (
    appEvent: (
      | OpenExponentConversationEvent
      | OpenExponentWebsiteEvent
      | OpenExponentSocialsEvent
    )["name"],
  ) => () => void;
  onEventParticipationCardClick?: ComponentProps<typeof ParticipationPanel>["onEventCardClick"];
  isEmbedded?: boolean;
  actionGuard?: (action: () => void, fallback?: () => void, ignoreModal?: boolean) => void;
};

const Exhibitor: FC<ExhibitorProps> = (props) => {
  return <ExhibitorDrawerUnified {...props} withTicketing={true} />;
};

export default Exhibitor;
